var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.61426 0.75L0.896742 7.46752C0.70148 7.66278 0.70148 7.97936 0.896742 8.17462L7.61426 14.8921","stroke":"#222222","stroke-width":"1.5","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }